import { render, staticRenderFns } from "./placard_media_index.vue?vue&type=template&id=8fe2571e&scoped=true"
import script from "./placard_media_index.vue?vue&type=script&lang=js"
export * from "./placard_media_index.vue?vue&type=script&lang=js"
import style0 from "./placard_media_index.vue?vue&type=style&index=0&id=8fe2571e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe2571e",
  null
  
)

export default component.exports